module.exports = __webpack_public_path__ + "img/revdojo_logo_white.ac30270e.png";